interface SkeletonProps {
  className?: string;
}

export default function Skeleton({ className = '' }: SkeletonProps) {
  return <div className={`skeleton rounded-2xl ${className}`} />;
}

export function ModelCardSkeleton() {
  return (
    <div className="glass rounded-3xl p-3">
      <Skeleton className="h-36 rounded-2xl mb-3" />
      <Skeleton className="h-3 w-16 mb-2" />
      <Skeleton className="h-4 w-24 mb-1" />
      <Skeleton className="h-4 w-16" />
    </div>
  );
}

export function FeaturedCardSkeleton() {
  return (
    <div className="h-[340px] rounded-[32px] overflow-hidden glass">
      <Skeleton className="w-full h-full" />
    </div>
  );
}
